import React, { useState } from 'react'
import countriesList from './countries.json'
import statesList from './states.json'

import ApplyFormLabel from '../ApplyFormLabel'
import SelectField from 'components/SelectField'
import ApplyStepIcon from 'components/ApplyStepIcon'
import ApplyStepButtons from 'components/ApplyStepButtons'

import s from './ApplyFormDetails.module.css'
import classNames from 'classnames'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css'
// import { PhoneNumberUtil } from 'google-libphonenumber';
import isModellinkSite from '../../../helpers/isModellinkSite'
import { useAtom } from 'jotai/index'
import { sitesAtom } from '../../../lib/atoms'
import * as Sentry from "@sentry/nextjs";

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const countryUnitedStatesValue = 'United States'

// const phoneUtil = PhoneNumberUtil.getInstance();

//TODO: setup proptypes
function ApplyFormDetails({ onSubmit, initialValues }) {
  const [sites] = useAtom(sitesAtom)
  const [errors, setErrors] = useState([])
  const [fieldValues, setFieldValues] = useState({
    firstName: initialValues.firstName || '',
    surname: initialValues.surname || '',
    email: initialValues.email || '',
    telephoneNumber: initialValues.telephoneNumber || '',
    dateOfBirthDay: initialValues.dateOfBirthDay || null,
    dateOfBirthMonth: initialValues.dateOfBirthMonth || null,
    dateOfBirthYear: initialValues.dateOfBirthYear || null,
    office: initialValues.office || (isModellinkSite() ? 'modellink' : null),
    country: initialValues.country || null,
    state: initialValues.state || null,
    city: initialValues.city || '',
  })



  const [showUsStates, setShowUsStates] = React.useState(false)
  const States = () => (
    <SelectField
      onChange={handleAttrChange}
      name='state'
      options={statesList}
      label='Select state'
      value={fieldValues.state}
      className={s.selectField}
      optionsClassName={s.selectOptions}
      optionClassName={s.selectOption}
      inputClassName={s.selectInput}
    />
  )

  const handleAttrChange = (attr, val) => {
    const fields = { ...fieldValues }
    fields[attr] = val
    setFieldValues(fields)

    // And also a special case for Countries
    if (attr === 'country') {
      if (val === countryUnitedStatesValue) {
        // Display the states drop down if the country is America
        setShowUsStates(true)
      } else {
        setShowUsStates(false)
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = Object.keys(fieldValues).filter((f) => {
      // I'm going to leave out this phone number validation for now, but I might add it in later
      // if (f === 'telephoneNumber') {
      //     const number = phoneUtil.parseAndKeepRawInput(fieldValues.telephoneNumber)
      //     if (!phoneUtil.isValidNumber(number)) {
      //       return true;
      //     }
      // }
      if (f === 'state' && fieldValues.country !== countryUnitedStatesValue) {
        // We don't want to validate the state field if the country is the United States
        return false
      }

      return !fieldValues[f]
    })

    const submitValues = {
      ...fieldValues,
      state: fieldValues.country === countryUnitedStatesValue ? fieldValues.state : null,
      dateOfBirth: `${fieldValues.dateOfBirthDay}/${fieldValues.dateOfBirthMonth}/${fieldValues.dateOfBirthYear}`,
    }

    Sentry.addBreadcrumb({
      category: 'form',
      message: 'Apply Form Details Submitted',
      level: 'debug',
      data: submitValues,
    })

    if (newErrors.length) {
      setErrors(newErrors)
    } else {
      onSubmit(submitValues)
    }
  }

  const earliestBirthDay = new Date().getFullYear() - 14

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Your Details</h1>
        <p className={s.text}>Please tell us a little about yourself</p>
        <div className={s.columns}>
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel
                errors={errors}
                attrs={[{ attr: 'firstName', label: 'First name' }, 'surname']}
                label='Your Name'
              />
              <input
                type='text'
                placeholder='First name'
                id='firstName'
                name='firstName'
                className={s.input}
                value={fieldValues.firstName}
                onChange={(e) => handleAttrChange('firstName', e.target.value)}
              />
            </div>
          </div>
          <div className={s.column}>
            <div className={s.field}>
              <input
                type='text'
                placeholder='Surname'
                className={classNames([s.input, s.surname])}
                name='surname'
                value={fieldValues.surname}
                onChange={(e) => handleAttrChange('surname', e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className={s.columns}>
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel errors={errors} attr='email' label='Email' />
              <input
                type='email'
                placeholder='name@domain.com'
                id='email'
                name='email'
                value={fieldValues.email}
                className={s.input}
                onChange={(e) => handleAttrChange('email', e.target.value)}
              />
            </div>
          </div>
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel errors={errors} attr='telephoneNumber' label='Telephone number' />
              <PhoneInput
                onChange={(value) => handleAttrChange('telephoneNumber', value)}
                value={fieldValues.telephoneNumber}
                preferredCountries={['fr', 'it', 'se', 'gb', 'us']}
                inputClassName={s.input}
              />


              {/*<IntlTelInput*/}
              {/*  containerClassName={classNames(['intl-tel-input', s.intTelInput])}*/}
              {/*  inputClassName={s.input}*/}
              {/*  onPhoneNumberChange={(isValid, value) => handleAttrChange('telephoneNumber', value)}*/}
              {/*  fieldId="telephoneNumber"*/}
              {/*  fieldName="telephoneNumber"*/}
              {/*  defaultValue={fieldValues.telephoneNumber}*/}
              {/*  preferredCountries={['fr','it','se','gb','us']}*/}
              {/*  />*/}
            </div>
          </div>
        </div>
        <div className={s.columns}>
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel
                errors={errors}
                attrs={[
                  { attr: 'dateOfBirthDay', label: 'Date of birth day' },
                  { attr: 'dateOfBirthMonth', label: 'Date of birth month' },
                  { attr: 'dateOfBirthYear', label: 'Date of birth year' },
                ]}
                label='Date of birth'
              />
              <div className={s.dobFields}>
                <SelectField
                  onChange={handleAttrChange}
                  name='dateOfBirthDay'
                  options={Array.from(Array(31), (_, x) => {
                    const val = x + 1
                    return {
                      label: val,
                      value: val.toString().length === 1 ? `0${val}` : val,
                    }
                  })}
                  label='Day'
                  value={fieldValues.dateOfBirthDay}
                  className={s.dobInput}
                  inputClassName={s.selectInput}
                  optionsClassName={s.selectOptions}
                  optionClassName={s.selectOption}
                />
                <SelectField
                  onChange={handleAttrChange}
                  name='dateOfBirthMonth'
                  options={Array.from(Array(12), (_, x) => {
                    const val = x + 1
                    return {
                      label: monthNames[x],
                      value: val.toString().length === 1 ? `0${val}` : val,
                    }
                  })}
                  label='Month'
                  value={fieldValues.dateOfBirthMonth}
                  className={s.dobInput}
                  inputClassName={s.selectInput}
                  optionsClassName={s.selectOptions}
                  optionClassName={s.selectOption}
                />
                <SelectField
                  onChange={handleAttrChange}
                  name='dateOfBirthYear'
                  options={Array.from(
                    Array(100),
                    (_, x) => earliestBirthDay - x,
                  )}
                  label='Year'
                  value={fieldValues.dateOfBirthYear}
                  className={s.dobInput}
                  optionsClassName={s.selectOptions}
                  optionClassName={s.selectOption}
                  inputClassName={s.selectInput}
                />
              </div>
            </div>
          </div>
        </div>
        <hr className={s.divider} />
        <h1 className={s.title}>Your Location</h1>
        {!isModellinkSite() && (<p className={s.text}>Please choose the Select office closest to you</p>)}
        <div className={s.columns}>
          {!isModellinkSite() && (
            <div className={s.column}>
              <div className={s.field}>
                <ApplyFormLabel
                  errors={errors}
                  attr='office'
                  label='Select Office'
                />
                <SelectField
                  onChange={handleAttrChange}
                  name='office'
                  options={sites.map((a) => ({
                    label: a.name,
                    value: a.path.replace(/\//g, ''),
                  }))}
                  label='Please select your local office'
                  value={fieldValues.office}
                  optionsClassName={s.selectOptions}
                  optionClassName={s.selectOption}
                  inputClassName={s.selectInput}
                />
              </div>
            </div>
          )}
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel
                errors={errors}
                attrs={['country', 'state', 'city']}
                label='Country of residence'
              />
              <SelectField
                onChange={handleAttrChange}
                name='country'
                options={countriesList}
                label='Select country of residence'
                value={fieldValues.country}
                className={s.selectField}
                optionsClassName={s.selectOptions}
                optionClassName={s.selectOption}
                inputClassName={s.selectInput}
              />
              {showUsStates ? <States /> : null}
              <input
                type='text'
                name='city'
                value={fieldValues.city}
                placeholder='City / Town'
                className={s.input}
                onChange={(e) => handleAttrChange('city', e.target.value)}
              />
            </div>
          </div>
        </div>
        <ApplyStepButtons back='/apply' />
      </form>
      <ApplyStepIcon step='1' />
    </div>
  )
}

export default ApplyFormDetails
